import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getPagesBySlug } from "../../services/apiService";
import useSlug from "../SlugComp";
import SEO from "../Seo";
import parse from "html-react-parser";

// Blog content map - can be expanded with more blog posts
const blogContentMap = {
  "digital-transformation-companies-in-hyderabad": {
    id: 1,
    title: "Digital Transformation Companies in Hyderabad",
    category: "Digital Transformation",
    image:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=1200",
    date: "July 30, 2026",
    author: "TechProjects",
    readTime: "10 minutes",
    excerpt:
      "Looking for digital transformation companies in Hyderabad? TechProjects delivers AI, cloud, ERP, and IT consulting solutions across India.",
    content: [
      {
        type: "heading2",
        text: "Why Choose TechProjects for Digital Transformation Services?",
      },
      {
        type: "paragraph",
        text: 'Digital transformation is reshaping how businesses operate, compete, and deliver value to customers. Organizations across industries are investing in cloud computing, artificial intelligence (AI), automation, data analytics, and enterprise applications to improve efficiency and accelerate growth. As businesses search for reliable digital transformation companies in Hyderabad and trusted  <a href="https://techprojects.com/services/dst" class="text-blue-600 hover:text-blue-800">digital transformation companies in India, </a> choosing the right technology partner is essential for long-term success.',},
  
    {
        type: "paragraph",
        text: "TechProjects is a leading IT consulting and digital transformation company that helps organizations modernize their operations with innovative, scalable, and future-ready technology solutions.",},
    {
        type: "heading2",
        text: "What Are Digital Transformation Services?",
      },
      {
        type: "paragraph",
        text: "Digital transformation services involve integrating modern digital technologies into business processes to improve productivity, enhance customer experiences, and drive innovation. These services typically include:"
    },
    {
        type: "bulletList",
        items: [
          "Digital Transformation Consulting",
          "Cloud Migration and Cloud Strategy",
          "Artificial Intelligence (AI) Solutions",
          "Enterprise Application Development",
          "ERP Consulting and Implementation",
          "Cybersecurity Services",
          "Data Analytics and Business Intelligence",
          "DevOps and Platform Engineering"
         
        ],
      },
      {
        type: "paragraph",
        text: "By implementing these solutions, businesses can streamline operations, reduce costs, and respond quickly to changing market demands."
    },
      {
        type: "heading2",
        text: "Why Choose TechProjects?",
      },
      {
        type: "paragraph",
        text: 'TechProjects has established itself among the trusted <a href="https://techprojects.com/services/dst" class="text-blue-600 hover:text-blue-800">digital transformation companies in Hyderabad  </a> by delivering customized solutions that align with each clients business objectives.',},
      {
        type: "heading3",
        text: "End-to-End Digital Transformation Expertise",
      },
      {
        type: "paragraph",
        text: "From strategy and planning to implementation and ongoing support, TechProjects provides complete digital transformation services under one roof. Our experts work closely with organizations to identify opportunities, optimize processes, and implement the right technologies.",
      },
      {
        type: "heading3",
        text: "Industry-Focused Solutions",
      },
      {
        type: "paragraph",
        text: "We understand that every industry has unique challenges. Our team delivers tailored digital transformation solutions for healthcare, banking, manufacturing, retail, education, logistics, and other sectors, ensuring measurable business outcomes.",
      },
      {
        type: "heading3",
        text: "Advanced Technologies",
      },
      {
        type: "paragraph",
        text: "TechProjects helps businesses adopt the latest technologies, including Artificial Intelligence, Cloud Computing, Automation, ERP Solutions, Cybersecurity, and Data Analytics. These technologies improve operational efficiency while enabling innovation and business agility.",
      },
      {
        type: "heading2",
        text: "Why Businesses Trust TechProjects",
      },
      {
        type: "paragraph",
        text: "Among the many digital transformation companies in India, TechProjects stands out because of its customer-first approach, experienced consultants, and commitment to delivering measurable results.",
      },
      {
        type: "paragraph",
        text: "Our proven methodology includes:",
      },
      {
        type: "bulletList",
        items: [
           "Business Assessment",
           "Digital Strategy Development",
           "Solution Design",
           "Technology Implementation",
           "Testing and Deployment",
           "Continuous Support and Optimization", 
        ],
      },
      {
        type: "paragraph",
        text: "This structured approach minimizes risks and ensures successful digital transformation projects.",
      },
      {
        type: "heading2",
        text: "Benefits of Partnering with TechProjects",
      },
      {
        type: "paragraph",
        text: "Choosing TechProjects offers several advantages:",
      },
      {
        type: "bulletList",
        items: [
          "Improved operational efficiency",
          "Faster business innovation",
          "Enhanced cybersecurity",
          "Reduced operational costs",
          "Scalable cloud solutions",
          "AI-driven business automation",
          "Better customer experiences",
          "Data-driven decision-making"
         
        ],
      },
      {
        type: "paragraph",
        text: "These benefits help organizations remain competitive in today's rapidly evolving digital landscape.",
      },
      {
        type: "heading2",
        text: "Why TechProjects Is the Right Digital Transformation Partner",
      },
      {
        type: "paragraph",
        text: 'Businesses looking for experienced digital transformation companies in Hyderabad or dependable digital transformation companies in India need a partner that combines technology expertise with business strategy. <a href="https://techprojects.com/" class="text-blue-600 hover:text-blue-800"> TechProjects  </a> delivers innovative, secure, and scalable solutions that help organizations achieve sustainable growth while maximizing return on technology investments.',},
      {
        type: "paragraph",
        text: "Whether you are modernizing legacy systems, migrating to the cloud, implementing ERP solutions, or adopting AI-powered automation, TechProjects provides end-to-end support throughout your digital transformation journey.",
      },
      
      {
        type: "heading2",
        text: "Conclusion",
      },
      {
        type: "paragraph",
        text: "Digital transformation is no longer a choice.it is a business necessity. Partnering with the right technology consulting company can significantly impact your organization's success. TechProjects combines industry expertise, modern technologies, and a customer-centric approach to deliver digital transformation solutions that drive measurable business results.",
      },
      {
        type: "paragraph",
        text: "If you are searching for trusted digital transformation companies in Hyderabad or leading digital transformation companies in India, TechProjects is ready to help you innovate, transform, and grow with confidence.",
      },
      {
        type: "heading2",
        text: "Frequently Asked Questions (FAQs) :",
      },
      {
        type: "heading3",
        text: "1. What are digital transformation services? :",
      },
      {
        type: "paragraph",
        text: "Digital transformation services help businesses adopt technologies such as AI, cloud computing, automation, ERP, and data analytics to improve efficiency, streamline operations, and enhance customer experiences.",
      },
      {
        type: "heading3",
        text: "2. Why choose TechProjects for digital transformation services?",
      },
      {
        type: "paragraph",
        text: "TechProjects provides end-to-end digital transformation solutions, including IT consulting, cloud migration, AI implementation, ERP consulting, cybersecurity, and application modernization. Our customized approach helps businesses accelerate innovation and achieve measurable results.",
      },
      {
        type: "heading3",
        text: "3. Which are the best digital transformation companies in Hyderabad?",
      },
      {
        type: "paragraph",
        text: "Several companies offer digital transformation services in Hyderabad, but TechProjects stands out for its expertise in AI, cloud, ERP, digital engineering, and enterprise consulting, making it one of the trusted digital transformation companies in Hyderabad.",
      },
      {
        type: "heading3",
        text: "4. What should I look for when choosing a digital transformation company in India?",
      },
      {
        type: "paragraph",
        text: "Choose a company with proven industry experience, expertise in emerging technologies, successful project delivery, strong security practices, and ongoing support. TechProjects combines these capabilities to help businesses achieve successful digital transformation.",
      },
      {
        type: "heading3",
        text: "5. How can TechProjects help my business with digital transformation?",
      },
      {
        type: "paragraph",
        text: "TechProjects helps businesses modernize legacy systems, migrate to the cloud, implement AI and automation, deploy ERP solutions, strengthen cybersecurity, and optimize business processes, making it a trusted partner among digital transformation companies in India.",
      },

    ],
    relatedArticles: [
      {
        title: "Cloud Migration Best Practices",
        image:
          "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=400",
        category: "Cloud",
        slug: "cloud-migration-best-practices",
      },
      {
        title: "React Performance Optimization",
        image:
          "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=400",
        category: "React",
        slug: "react-performance-optimization",
      },
      {
        title: "DevOps Automation with CI/CD",
        image:
          "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=400",
        category: "DevOps",
        slug: "devops-automation-cicd",
      },
    ],
  },
};

function BlogDetail() {
  let slug = useSlug();
  const [metaData, setMetaData] = useState({});
  // useEffect(() => {
  //   const fetchMetaData = async () => {
  //     const data = await getPagesBySlug(slug);
  //     setMetaData(data?.meta || {});
  //   };
  //   fetchMetaData();
  // }, [slug]);
  // slug = useParams();
 useEffect(() => {
  const fetchData = async () => {
      const data = await getPagesBySlug(slug.toLowerCase());
      setMetaData(data.data);
    };

      fetchData();},[slug]);
  // console.log(slug+ "test")
  const navigate = useNavigate();
  const blog = blogContentMap["digital-transformation-companies-in-hyderabad"];

  if (!blog) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Blog post not found
          </h2>
          <p className="text-gray-600 mb-8">
            The article you're looking for doesn't exist.
          </p>
          <button
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors duration-200"
            onClick={() => navigate("/blogs")}
          >
            Back to Blog
          </button>
        </div>
      </div>
    );
  }

  const renderContent = () => {
    return blog.content.map((section, index) => {
      switch (section.type) {
        case "heading2":
          return (
            <h2
              key={index}
              className="text-3xl font-bold text-gray-900 mt-8 mb-4"
            >
              {parse(section.text)}
            </h2>
          );
        case "heading3":
          return (
            <h3
              key={index}
              className="text-2xl font-bold text-blue-600 mt-6 mb-3"
            >
              {parse(section.text)}
            </h3>
          );
        case "paragraph":
          return (
            <p key={index} className="text-gray-700 leading-relaxed mb-4">
              {parse(section.text)}
            </p>
          );
        case "bulletList":
          return (
            <ul key={index} className="list-disc list-inside space-y-2 mb-4 text-gray-700">
              {section.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          );
        default:
          return null;
      }
    });
  };

  return (
    <>
      {/* Hero Section with Image */}
      <section
        className="relative h-96 md:h-[500px] bg-cover bg-center flex items-center justify-center text-white"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('${blog.image}')`,
        }}
      >
        <div className="text-center max-w-3xl px-4">
          <span className="inline-block bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">
            {blog.category}
          </span>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            {blog.title}
          </h1>
          <p className="text-lg text-gray-100">
            Looking for the best IT consulting company in Hyderabad? Learn how to choose the right technology partner and discover how Tech projects deliver cloud, AI, cybersecurity, and digital transformation solutions.
          </p>
        </div>
      </section>

      {/* Article Content */}
      <SEO {...metaData} />
      <section className="py-12 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Article Meta */}
          <div className="mb-8 pb-8 border-b border-gray-200 flex justify-between items-center flex-wrap gap-4">
            <div>
              <p className="text-gray-600 mb-1">By {blog.author}</p>
              <p className="text-gray-600">{blog.date}</p>
            </div>
            <div>
              <span className="text-sm text-gray-600">
                Estimated read time: {blog.readTime}
              </span>
            </div>
          </div>

          {/* Article Body */}
          <div className="prose prose-lg max-w-none">
            {renderContent()}

            {/* Call to Action */}
            {/* <div className="mt-8 p-6 bg-blue-50 border-l-4 border-blue-600 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                Ready to Transform Your Development Process?
              </h3>
              <p className="text-gray-700 mb-4">
                TechProjects specializes in AI-driven software solutions and
                digital transformation. Our experts can help you integrate AI
                into your development workflows efficiently and securely.
              </p>
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors duration-200"
                onClick={() => {
                  window.location.href = "/Contact";
                }}
              >
                Get Started Today
              </button>
            </div> */}
          </div>

          {/* Share Section */}
          <div className="mt-8 pt-8 border-t border-gray-200 flex justify-between items-center flex-wrap gap-4">
            <div>
              <p className="text-gray-700 font-semibold">Share this article:</p>
            </div>
            <div className="flex gap-3">
              <button className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200">
                Facebook
              </button>
              <button className="bg-blue-400 hover:bg-blue-500 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200">
                Twitter
              </button>
              <button className="bg-blue-700 hover:bg-blue-800 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200">
                LinkedIn
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Related Articles */}
      {/* <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
            Related Articles
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blog.relatedArticles.map((article, index) => (
              <div
                key={index}
                className="group bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
                onClick={() => navigate(`/blog/${article.slug}`)}
              >
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="p-6">
                  <span className="inline-block bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-xs font-semibold mb-3">
                    {article.category}
                  </span>
                  <h3 className="font-bold text-gray-900">{article.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Back to Blog Button */}
      <section className="py-8 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <button
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-full transition-colors duration-200"
            onClick={() => navigate("/blogs")}
          >
            ← Back to Blog
          </button>
        </div>
      </section>
    </>
  );
}

export default BlogDetail;
